import {
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Popover,
  Select,
  Space,
  Spin,
  Tooltip
} from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined, ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import './index.css';
import PropTypes from 'prop-types';

import { ReactSession } from 'react-client-session';
import { setCustomerAddress, setPickupDetails, setStepCount } from '../store/actionCreators';
import { useDispatch, useSelector } from 'react-redux';
import {
  addPickUp,
  checkZipCode,
  getDeliverWindows,
  getPickupWindows,
  getExtraWork,
  getExtraWorkInventory,
  getPickUp,
  getUnavaliableDays,
  getBlockedDays
} from '../../../data/API';
import moment from 'moment';
import GoogleAutoComplete from 'react-google-autocomplete';
import { handleEventClick } from "../index";
import fetchBubbleContent from '../../../utils';
import { processTimeSlotsResponse, getSubmissionValue } from '../../../utils/timeSlotUtils';

const PickupDetails = (props) => {
  const dispatch = useDispatch();
  const session = ReactSession.get('session');
  const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;

  const { isParentNextStepClicked, setParentNextStepClicked } = props;

  const currentStep = useSelector((state) => state.package.currentStep);

  const [form] = Form.useForm();
  const [timingOne, setTimingOne] = useState(null);
  const [timingTwo, setTimingTwo] = useState(null);
  const [pickupDate, setPickupDate] = useState('');
  const [originalPickupDate, setOriginalPickupDate] = useState('');
  const [showBlockedDateMessage, setShowBlockedDateMessage] = useState(false);
  const [deliveryWindows, setDeliveryWindows] = useState([]);
  const [extraWork, setExtraWork] = useState([]);
  const [deliveryAddress, setDeliveryAddress] = useState(null);
  const [zipCodeError, setZipCodeError] = useState(null);
  const [deliveryAddressError, setDeliveryAddressError] = useState(null);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loadingPickupDate, setLoadingPickupDate] = useState(false);
  const [bubbleContents, setBubbleContents] = useState({});
  const { selectedPackage } = useSelector((state) => state.package.choosePackage);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const obj = { title: "Stairs and Elevators" }; 

  const pickupInfo = useSelector((state) => state.package.pickupDetails.pickupInfo);

  useEffect(() => {
    if (pickupInfo?.pickup_address) setDeliveryAddress(pickupInfo?.pickup_address);

    if (pickupInfo && Object.keys(pickupInfo).length > 0) {
      form.setFieldsValue({
        pickupDate: moment(pickupInfo?.pickup_date),
        apt: pickupInfo?.apt_number,
        description: pickupInfo?.description,
        pickupWindow1: pickupInfo?.window_1,
        pickupWindow2: pickupInfo?.window_2,
        extraWork: pickupInfo?.extra_work
      });

      setTimingOne(pickupInfo?.window_1);
      setTimingTwo(pickupInfo?.window_2);

      // incase user chnages the date after pickup date is given
      if (pickupInfo && pickupInfo?.pickup_date) {
        setPickupDate(pickupInfo?.pickup_date);
        setLoadingPickupDate(true);
      }
    }
  }, [pickupInfo]);

  const deliveryDetails = useSelector((state) => state.package.deliveryDetails.deliveryInfo);
  const { selectedRentalPeriod } = useSelector((state) => state.package.choosePackage);

  const checkIfPickupWasAdjusted = async (actualPickupDate) => {
    try {
      if (!deliveryDetails?.delivery_date) {
        return;
      }

      if (!selectedRentalPeriod?.id) {
        return;
      }

      let rentalWeeks;
      
      if (selectedRentalPeriod.period) {
        const periodMatch = selectedRentalPeriod.period.match(/(\d+)\s*week/i);
        rentalWeeks = periodMatch ? parseInt(periodMatch[1]) : 0;
      } else {
        rentalWeeks = selectedRentalPeriod.rental_int
      }

      const deliveryDate = moment(deliveryDetails.delivery_date);
      const calculatedPickupDate = deliveryDate.clone().add(rentalWeeks, 'weeks').format('YYYY-MM-DD');
     
      if (calculatedPickupDate === actualPickupDate) {
        return;
      }
      const blockedDatesResponse = await getUnavaliableDays();
      const blockedDates = blockedDatesResponse?.data?.results || [];
      const wasCalculatedDateBlocked = blockedDates.some(blockedDate => 
        moment(blockedDate.date).format('YYYY-MM-DD') === calculatedPickupDate
      );

      if (wasCalculatedDateBlocked) {
        setOriginalPickupDate(calculatedPickupDate);
        setShowBlockedDateMessage(true);
      } else {
        console.log('Calculated date was not blocked - no message needed');
      }
      
    } catch (error) {
      console.error('Error checking pickup adjustment:', error);
    }
  };

  useEffect(() => {
    if (pickupInfo && !('pickup_date' in pickupInfo)) getDate();
    if (pickupInfo && pickupInfo.pickup_date == null) getDate();
    getDeliverySlots(); // Will be called again with pickupDate when it's available
    // getExtarworkInfo();

    if (selectedPackage && selectedPackage.id) {
      setSelectedProductId(selectedPackage.id);
    }

    window.scrollTo({
      top: props.tabref.current.offsetTop - 100,
      behavior: 'smooth'
    });
  }, []);

  useEffect(() => {
    if (pickupDate && deliveryDetails?.delivery_date && selectedRentalPeriod?.id) {
      console.log('Running pickup date check with all data available...');
      checkIfPickupWasAdjusted(pickupDate);
    }
  }, [pickupDate, deliveryDetails, selectedRentalPeriod]);

  // NEW: Fetch day-specific pickup slots when pickup date becomes available
  useEffect(() => {
    if (pickupDate) {
      console.log('useEffect - Fetching pickup slots for date:', pickupDate);
      getDeliverySlots(pickupDate);
    } else {
      console.log('useEffect - No pickupDate, clearing slots');
      setDeliveryWindows([]);
    }
  }, [pickupDate]);

  const getDate = async () => {
    try {
      let date = await getPickUp(session);
      if (
        date &&
        date?.data &&
        date?.data?.results?.length > 0 &&
        date?.data?.results[0]['pickup_date']
      ) {
        const fetchedPickupDate = date?.data?.results[0]['pickup_date'];
        setPickupDate(fetchedPickupDate);
        setLoadingPickupDate(true);
      }
    } catch (err) {
      return message.error('Error occurred while getting your pickup date', err);
    }
  };

  const getDeliverySlots = async (calculatedPickupDate = null) => {
    try {
      let dayName = null;
      if (calculatedPickupDate) {
        dayName = moment(calculatedPickupDate).format('dddd');
        console.log('Extracted pickup day name:', dayName, 'from date:', calculatedPickupDate);
      }

      console.log('Calling pickup API with dayName:', dayName);
      let pickupResponse = await getPickupWindows(dayName);
      console.log('Pickup API response:', pickupResponse);

      if (pickupResponse?.data?.results && pickupResponse.data.results.length > 0) {
        console.log('Pickup slots found:', pickupResponse.data.results);
        if (pickupResponse.data.results[0].day_of_week) {
          console.log('Processing day-specific pickup slots - API already processed them');
          const processedSlots = pickupResponse.data.results.map((slot, index) => ({
            id: slot.id,
            database_id: slot.id,
            start_time: slot.start_time,
            end_time: slot.end_time,
            display_value: `${slot.start_time} - ${slot.end_time}`,
            submission_value: slot.id,
            is_day_specific: true,
            slot_type: slot.slot_type,
            day_of_week: slot.day_of_week
          }));

          const anytimeSlots = processedSlots.filter(slot =>
            slot.start_time?.toLowerCase().includes('anytime') ||
            slot.end_time?.toLowerCase().includes('anytime') ||
            slot.slot_type?.toLowerCase() === 'anytime'
          );
          const regularSlots = processedSlots.filter(slot =>
            !slot.start_time?.toLowerCase().includes('anytime') &&
            !slot.end_time?.toLowerCase().includes('anytime') &&
            slot.slot_type?.toLowerCase() !== 'anytime'
          );

          const finalProcessedSlots = [...regularSlots, ...anytimeSlots];

          console.log('Final processed pickup slots:', finalProcessedSlots);
          setDeliveryWindows(finalProcessedSlots);
        } else {
          console.log('Using generic pickup slots');
          const genericSlots = pickupResponse.data.results.map((slot, index) => ({
            id: slot.id,
            database_id: slot.id,
            start_time: slot.start_time,
            end_time: slot.end_time,
            display_value: `${slot.start_time} - ${slot.end_time}`,
            submission_value: slot.id,
            is_day_specific: false,
            slot_type: slot.slot_type,
            day_of_week: slot.day_of_week
          }));

          const anytimeSlots = genericSlots.filter(slot =>
            slot.start_time?.toLowerCase().includes('anytime') ||
            slot.end_time?.toLowerCase().includes('anytime') ||
            slot.slot_type?.toLowerCase() === 'anytime'
          );
          const regularSlots = genericSlots.filter(slot =>
            !slot.start_time?.toLowerCase().includes('anytime') &&
            !slot.end_time?.toLowerCase().includes('anytime') &&
            slot.slot_type?.toLowerCase() !== 'anytime'
          );

          const sortedRegularSlots = regularSlots.sort((a, b) => {
            const timeA = moment(a.start_time, 'h:mm A');
            const timeB = moment(b.start_time, 'h:mm A');
            return timeA.diff(timeB);
          });

          const sortedGenericSlots = [...sortedRegularSlots, ...anytimeSlots];

          console.log('Formatted and sorted generic pickup slots:', sortedGenericSlots);
          setDeliveryWindows(sortedGenericSlots);
        }
      } else {
        console.log('No pickup slots found - fallback to delivery slots');
        let deliveryResponse = await getDeliverWindows(dayName);
        if (deliveryResponse?.data?.results) {
          if (deliveryResponse.data.results[0]?.day_of_week) {
            console.log('Processing day-specific delivery slots for pickup');
            const processedSlots = deliveryResponse.data.results.map((slot, index) => ({
              id: slot.id,
              database_id: slot.id,
              start_time: slot.start_time,
              end_time: slot.end_time,
              display_value: `${slot.start_time} - ${slot.end_time}`,
              submission_value: slot.id,
              is_day_specific: true,
              slot_type: slot.slot_type,
              day_of_week: slot.day_of_week
            }));

            const anytimeSlots = processedSlots.filter(slot =>
              slot.start_time?.toLowerCase().includes('anytime') ||
              slot.end_time?.toLowerCase().includes('anytime') ||
              slot.slot_type?.toLowerCase() === 'anytime'
            );
            const regularSlots = processedSlots.filter(slot =>
              !slot.start_time?.toLowerCase().includes('anytime') &&
              !slot.end_time?.toLowerCase().includes('anytime') &&
              slot.slot_type?.toLowerCase() !== 'anytime'
            );
            const finalProcessedSlots = [...regularSlots, ...anytimeSlots];
            
            console.log('Final processed delivery slots for pickup:', finalProcessedSlots);
            setDeliveryWindows(finalProcessedSlots);
          } else {
            const genericSlots = deliveryResponse.data.results.map((slot, index) => ({
              id: slot.id,
              database_id: slot.id,
              start_time: slot.start_time,
              end_time: slot.end_time,
              display_value: `${slot.start_time} - ${slot.end_time}`,
              submission_value: slot.id,
              is_day_specific: false,
              slot_type: slot.slot_type,
              day_of_week: slot.day_of_week
            }));

            const anytimeSlots = genericSlots.filter(slot =>
              slot.start_time?.toLowerCase().includes('anytime') ||
              slot.end_time?.toLowerCase().includes('anytime') ||
              slot.slot_type?.toLowerCase() === 'anytime'
            );
            const regularSlots = genericSlots.filter(slot =>
              !slot.start_time?.toLowerCase().includes('anytime') &&
              !slot.end_time?.toLowerCase().includes('anytime') &&
              slot.slot_type?.toLowerCase() !== 'anytime'
            );

            const sortedRegularSlots = regularSlots.sort((a, b) => {
              const timeA = moment(a.start_time, 'h:mm A');
              const timeB = moment(b.start_time, 'h:mm A');
              return timeA.diff(timeB);
            });

            const sortedGenericSlots = [...sortedRegularSlots, ...anytimeSlots];

            console.log('Formatted and sorted generic delivery slots for pickup:', sortedGenericSlots);
            setDeliveryWindows(sortedGenericSlots);
          }
        }
      }
    } catch (err) {
      return message.error('error fetching delivery windows', err);
    }
  };

  useEffect(() => {
    if (selectedProductId) {
      getExtarworkInfo(selectedProductId);
    }
  }, [selectedProductId]);

  const getExtarworkInfo = async (productId = null) => {
    console.log("Calling getExtraWork with productId:", productId);
    try {
      let response = await getExtraWorkInventory(productId, 'pickup');
      console.log("Response from getExtraWork:", response);
      if (response?.data) {
        setExtraWork(response?.data.results);
      }
    } catch (err) {
      console.error("Error fetching extra work:", err);
      return message.error('error fetching extra work info windows', err);
    }
  };

  const onFinish = (val) => {
    message.success('Submit success!');
  };

  const onFinishFailed = () => {
    message.error('Submit failed!');
  };

  const prevStep = () => {
    dispatch(setStepCount(currentStep - 1));
  };

  const handleTimingOneChange = (evt) => {
    setTimingOne(evt);

    if (evt == timingTwo) {
      setTimingTwo('');
    }
  };

  const handleTimingTwoChange = (evt) => {
    setTimingTwo(evt);
  };

  const setAddress = async (place) => {
    setDeliveryAddress(place?.formatted_address);

    let postal, country, city, state;
    place.address_components.forEach((address_element) => {
      if (address_element.types.includes('postal_code')) postal = address_element.long_name;
      if (address_element.types.includes('country')) country = address_element.short_name;
      if (address_element.types.includes('locality')) city = address_element.long_name;
      if (address_element.types.includes('administrative_area_level_1'))
        state = address_element.long_name;
    });

    const address = {
      city: city,
      country: country,
      line1: place?.formatted_address,
      state: state,
      postal: postal
    };

    dispatch(setCustomerAddress(address));

    let zipCodeRes = await checkZipCode({ deliveryzipcode: postal ? postal : '781006' });

    if (zipCodeRes?.data?.success === true) {
      setZipCodeError(null);
    } else {
      setZipCodeError(zipCodeRes?.data?.message_2);
    }
  };

  const onStairsSelected = async (value) => {
    let formValues = await form.validateFields();
    try {
      const window1SubmissionValue = getSubmissionValue(formValues?.pickupWindow1, deliveryWindows);
      const window2SubmissionValue = getSubmissionValue(formValues?.pickupWindow2, deliveryWindows);

      // Get selected display values for admin display
      const getSelectedDisplayValue = (selectedValue, windowSlots) => {
        console.log('PICKUP getSelectedDisplayValue - Input:', selectedValue, 'Slots:', windowSlots);
        if (!selectedValue || !windowSlots) return null;
        const selectedSlot = windowSlots.find(slot =>
          slot.display_value === selectedValue || slot.id === selectedValue || slot.id === parseInt(selectedValue)
        );
        console.log('PICKUP getSelectedDisplayValue - Found slot:', selectedSlot);
        const result = selectedSlot?.display_value || selectedValue;
        console.log('PICKUP getSelectedDisplayValue - Returning:', result);
        return result;
      };

      let data = {
        extra_work: value,
        session: session,
        pickup_date: moment(pickupDate).format('YYYY-MM-DD'),
        pickup_address: deliveryAddress,
        pickup_window_1: window1SubmissionValue,
        pickup_window_2: window2SubmissionValue,
        selected_window_1: getSelectedDisplayValue(formValues?.pickupWindow1, deliveryWindows),
        selected_window_2: getSelectedDisplayValue(formValues?.pickupWindow2, deliveryWindows)
      };

      if (formValues?.apt) {
        data['apt_number'] = formValues.apt;
      }

      if (formValues?.description) {
        data['description'] = formValues.description;
      }

      let pickupDetail = await addPickUp(data);

      if (pickupDetail?.data?.id) {
        pickupDetail['data']['window_1'] = formValues['pickupWindow1'];
        pickupDetail['data']['window_2'] = formValues['pickupWindow2'];
        pickupDetail['data']['window_1_id'] = window1SubmissionValue;
        pickupDetail['data']['window_2_id'] = window2SubmissionValue;
        dispatch(setPickupDetails(pickupDetail?.data));
      }
    } catch (err) {
      return message.error('Error while adding pickup info', err);
    }
  };

  const onSubmit = async () => {
    try {
      setIsFormSubmitted(true);

      let formValues = await form.validateFields();

      if (formValues.errorFields?.length) {
        setIsFormSubmitted(false);
        return;
      }

      if (zipCodeError) {
        setIsFormSubmitted(false);
        return;
      }

      if (!deliveryAddress) {
        setIsFormSubmitted(false);
        setDeliveryAddressError('Please select delivery address');
        return;
      }

      const window1SubmissionValue = getSubmissionValue(formValues?.pickupWindow1, deliveryWindows);
      const window2SubmissionValue = getSubmissionValue(formValues?.pickupWindow2, deliveryWindows);

      // Get selected display values for admin display
      const getSelectedDisplayValue = (selectedValue, windowSlots) => {
        console.log('PICKUP getSelectedDisplayValue - Input:', selectedValue, 'Slots:', windowSlots);
        if (!selectedValue || !windowSlots) return null;
        const selectedSlot = windowSlots.find(slot =>
          slot.display_value === selectedValue || slot.id === selectedValue || slot.id === parseInt(selectedValue)
        );
        console.log('PICKUP getSelectedDisplayValue - Found slot:', selectedSlot);
        const result = selectedSlot?.display_value || selectedValue;
        console.log('PICKUP getSelectedDisplayValue - Returning:', result);
        return result;
      };

      let data = {
        session: session,
        pickup_date: moment(pickupDate).format('YYYY-MM-DD'),
        pickup_address: deliveryAddress,
        pickup_window_1: window1SubmissionValue,
        pickup_window_2: window2SubmissionValue,
        selected_window_1: getSelectedDisplayValue(formValues?.pickupWindow1, deliveryWindows),
        selected_window_2: getSelectedDisplayValue(formValues?.pickupWindow2, deliveryWindows),
        extra_work: formValues?.extraWork?.id || formValues?.extraWork
      };

      if (formValues?.apt) {
        data['apt_number'] = formValues.apt;
      }

      if (formValues?.description) {
        data['description'] = formValues.description;
      }

      let pickupDetail = await addPickUp(data);

      if (pickupDetail?.data?.id) {
        pickupDetail['data']['window_1'] = formValues['pickupWindow1'];
        pickupDetail['data']['window_2'] = formValues['pickupWindow2'];
        pickupDetail['data']['window_1_id'] = window1SubmissionValue;
        pickupDetail['data']['window_2_id'] = window2SubmissionValue;
        dispatch(setPickupDetails(pickupDetail?.data));
        dispatch(setStepCount(currentStep + 1));
      }
    } catch (err) {
      setIsFormSubmitted(false);
      return message.error(err);
    }
  };

  const onAddresschange = (e) => {
    if (deliveryAddress && e.target.value == 0) {
      setDeliveryAddress('');
      setDeliveryAddressError('Please Select Delivery Address');
    }
  };

  useEffect(() => {
    if (isParentNextStepClicked) {
      setParentNextStepClicked(false);
      setTimeout(() => {
        onSubmit();
      }, 0);
    }
  }, [isParentNextStepClicked]);

  return (
    <div>
      <div className="steps" id="steps">
        <h2 className="shopping-cart-header text-white text-center py-2 fs-20 steps-title mb-0 ">
          Step 5: Pick Up Details
        </h2>
        <Card bordered={false} className="w-100 pl-3 pr-3 pt-3">
          <Spin spinning={isFormSubmitted} tip="processing...">
            <div className="pickup-info mb-4">
              <Spin tip="getting your pickup date..." spinning={!loadingPickupDate}>
                <p className="mb-2 text-left fs-16 fw-500">Your pickup date is:</p>
                {pickupDate ? (
                  <p className="mb-2 text-left fs-20 color-primary fw-600">
                    {moment(pickupDate).format('dddd MMMM DD, YYYY')}
                  </p>
                ) : (
                  ''
                )}
                
                {showBlockedDateMessage && (
                  <p className="mb-2" style={{
                    backgroundColor: '#e6f7ff',
                    border: '1px solid #e6f7ff',
                    borderRadius: '8px',
                    padding: '12px 14px',
                    color: '#856404',
                    fontSize: '12px',
                    lineHeight: '1.3'
                  }}>
                    <strong>Note:</strong> Your original pickup date ({moment(originalPickupDate).format('MMMM DD, YYYY')}) was not available. 
                    We have automatically assigned the next available date. You will not be charged for any additional days added to your original rental duration.
                  </p>
                )}
                
                <p className="mb-2 text-left fs-12 fw-500">
                 After placing your order, please visit our customer portal if you need to change the delivery or pickup date.
                </p>
              </Spin>
            </div>
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              initialValues={{
                pickupWindow1: null,
                pickupWindow2: null,
                rentalPeriod: '2weeks'
              }}
              style={{ position: 'relative', zIndex: 0 }}>
              <Row>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item
                    name="pickupWindow1"
                    label="Pick Up Window 1"
                    rules={[{ required: true, message: 'Please choose a pick up window 1' }]}>
                    <Select onClick={handleEventClick}
                      size="large"
                      placeholder="Select a time slot"
                      value={timingOne}
                      onChange={handleTimingOneChange}>
                      {deliveryWindows?.map((options, index) => {
                        const displayText = options?.display_value || 
                                          (options?.start_time && options?.end_time ? 
                                            `${options.start_time} - ${options.end_time}` : 
                                            options?.id);
                        
                        const optionValue = options?.display_value || options?.id;
                        
                        return (
                          <Select.Option key={`timing_one_${index}`} value={options?.id}>
                            {options?.start_time} - {options?.end_time}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item
                    name="pickupWindow2"
                    label="Pick Up Window 2"
                    rules={[{ required: true, message: 'Please choose a pick up window 2' }]}>
                    <Select onClick={handleEventClick}
                      size="large"
                      placeholder="Select a time slot"
                      onChange={handleTimingTwoChange}
                      value={timingTwo}
                      disabled={!timingOne}>
                      {deliveryWindows?.map((options, index) => {
                        if (options?.id != timingOne && options?.display_value != timingOne) {
                          const displayText = options?.display_value || 
                                            (options?.start_time && options?.end_time ? 
                                              `${options.start_time} - ${options.end_time}` : 
                                              options?.id);
                          
                          const optionValue = options?.display_value || options?.id;
                          
                          return (
                            <Select.Option key={`timing_two_${index}`} value={optionValue}>
                              {displayText}
                            </Select.Option>
                          );
                        }
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item
                    className="mandatory-field"
                    name="deliveryAddress"
                    label="Pickup Address"
                  // rules={[{ required: true, message: 'Please input the delivery address' }]}
                  >
                    <GoogleAutoComplete
                      className={
                        deliveryAddressError && !deliveryAddress
                          ? 'form-control delivery-address-field-error '
                          : 'form-control'
                      }
                      apiKey={apiKey}
                      onPlaceSelected={(place) => {
                        setAddress(place);
                      }}
                      options={{
                        types: ['address'],
                        componentRestrictions: { country: 'us' }
                      }}
                      defaultValue={deliveryAddress}
                      onChange={(e) => {
                        onAddresschange(e);
                      }}
                    />
                    <p className="mb-0 ant-form-item-explain-error">
                      {zipCodeError ? zipCodeError : null}
                    </p>
                    <p className="mb-0 ant-form-item-explain-error">
                      {deliveryAddressError && !deliveryAddress ? deliveryAddressError : null}
                    </p>
                    <p className="mb-0 text-success">
                      {!zipCodeError && deliveryAddress ? 'Services available in this area' : null}
                    </p>
                  </Form.Item>
                </Col>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item name="apt" label="Apt. #" rules={[{ required: false }]}>
                    {/* <Input size="large" placeholder="Apt" /> */}
                    <InputNumber
                      className="w-100"
                      placeholder="Apt."
                      size="large"
                      controls={false}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item
                    name="extraWork"
                    className='tool-tip'
                    label={
                      <div style={{ display: "flex", width: "100%", alignItems: "center", gap: "10px" }}>
                        <span>Do you have stairs or an elevator? </span>
                        <Popover 
                           content={
                             <div className="box-popover">
                               <p>{bubbleContents[obj.title] || 'Loading...'}</p>
                             </div>
                           }
                           trigger="hover"
                           onVisibleChange={(visible) => {
                             if (visible) {
                               console.log("Fetching content for:", obj.title);
                               fetchBubbleContent(obj.title, setBubbleContents);
                             }
                           }}
                         >
                           <i className="fa fa-info-circle color-primary" aria-hidden="true"></i>
                         </Popover>
                      </div>}
                    rules={[{ required: true, message: 'Please select an option from below' }]}>
                    <Select size="large" onChange={onStairsSelected} onClick={handleEventClick}>
                      {extraWork?.map((obj, index) => {
                        return (
                          <Select.Option
                            className="mobile-wide-option"
                            key={`extarwork_${index}`}
                            value={obj?.id}>{`${obj.title} ($${obj.price})`}</Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item
                    name="description"
                    label="Is there anything else we should know?"
                    rules={[{ required: false }]}>
                    <TextArea
                      autoSize={{
                        minRows: 3,
                        maxRows: 5
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Card>
      </div>
      <div className="row mt-4 p-2">
        <div className="col  d-flex justify-content-start align-items-center">
          <Button
            className="btn-previous-step red-border-button"
            icon={<ArrowLeftOutlined />}
            onClick={prevStep}
            size={'large'}>
            Previous Step
          </Button>
        </div>
        <div className="col  d-flex justify-content-end align-items-center">
          <Button
            className="btn-next-step red-button"
            icon={<ArrowRightOutlined />}
            onClick={onSubmit}
            size={'large'}
            loading={isFormSubmitted}>
            {!isFormSubmitted ? 'Next Step' : 'Submitting..'}
          </Button>
        </div>
      </div>
    </div>
  );
};

PickupDetails.propTypes = {
  isParentNextStepClicked: PropTypes.any,
  tabref: PropTypes.any,
  setParentNextStepClicked: PropTypes.func
};

export default PickupDetails;